import { createSelector } from '@reduxjs/toolkit';

import { getNonAllowedTypePackagingsForChildren } from 'core/api/productversion';
import { selectEditedProductVersion } from 'reducers/productVersion';

export const getEcxludedTypePackagings = createSelector(
  selectEditedProductVersion,
  getNonAllowedTypePackagingsForChildren,
);
